import Vue from 'vue';
import Vuex from 'vuex';
import StoreData from './store';
import 'livewire-vue';
import vSelect from 'vue-select';
import SearchForm from './vue/components/SearchForm.vue';
import PropertyAlertForm from './vue/components/PropertyAlertForm.vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-default.css';
import QuickSearchOpener from './vue/components/QuickSearchOpener.vue';
import QuickSearch from './vue/components/QuickSearch.vue';

window.Vue = Vue;

Vue.use(Vuex);
const store = new Vuex.Store(StoreData);

require('./bootstrap');

Vue.use(VueToast, {
    position: 'top'
});

vSelect.props.components.default = () => ({
    /*
    Deselect: {
        render: createElement => createElement('span', ''),
    },
    */
    OpenIndicator: {
        render: createElement => createElement('span', ''),
    },
});

Vue.component('v-select', vSelect);
Vue.component('search-form', SearchForm);
Vue.component('property-alert-form', PropertyAlertForm);
Vue.component('quicksearch-opener', QuickSearchOpener);
Vue.component('quicksearch', QuickSearch);

var app = new Vue({
    el: '#app',
    store: store,
});

var $ = require('jquery');
window.$ = $;
window.jQuery = $;
require('bootstrap');
require('./ajax');
require('./login-ajax');

import lozad from 'lozad';
window.Lozad = lozad(); // lazy loads elements with default selector as '.lozad'
window.Lozad.observe();

window.addEventListener('pageChanged', event => {
    window.Lozad.observe();
    window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
});

window.addEventListener('lozadObserve', event => {
    window.Lozad.observe();
});

$('#shareModal').on('show.bs.modal', function (event) {
    $(this).find('#sharetype').text($(event.relatedTarget).data('type'));
});

$(".hamburger").click(function(){$(".hamburger").toggleClass("is-active")});$(".search-toggle").click(function(){$(".search-wrap").toggleClass("is-active")});

// Example starter JavaScript for disabling form submissions if there are invalid fields
(function() {
    'use strict';
    window.addEventListener('load', function() {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        var validation = Array.prototype.filter.call(forms, function(form) {
            form.addEventListener('submit', function(event) {
                if (form.checkValidity() === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();
